import React from "react";
import "./GetStartedPop.css";
import { RxCross2 } from "react-icons/rx";
import FastImage from "../../FastImage";
import { auto } from "@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core";

const ComparePolicyPop = ({ setShowPop }) => {
  return (
    <>
      <div className="getstarted-outer">
        <div className="getstarted-body">
          <div className="getstarted-content">
            <div
              className="getstarted-cross"
              onClick={() => {
                setShowPop(false);
              }}
            >
              <RxCross2
                className="getstarted-cross-icon"
                onClick={() => {
                  setShowPop(false);
                }}
              />
            </div>
            <div className="getstarted-text">
              <h3>Policy</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam,
                facilis beatae{" "}
              </p>
            </div>
            <div className="getstarted-buttons-first">
              <button>Car Insurance</button>
              <button>Bike Insurance</button>
            </div>
            <div className="getstarted-buttons-first">
              <button>Health Insurance</button>
              <button>Term Insurance</button>
            </div>
          </div>
          <span className="bg-img-beema-d">
            <FastImage
              url={"Website%20Img/pop-up_a.webp?updatedAt=1718775653542"}
              width={auto}
              height={auto}
              alt={"beema"}
              src={"Website%20Img/pop-up_a.webp?updatedAt=1718775653542"}
            />
          </span>
        </div>
      </div>
    </>
  );
};

export default ComparePolicyPop;
